import template from "./helpIcon.hbs";
export class HelpIconElement extends HTMLElement {

    constructor() {
        super();
        let screenId;
        if (window.location.hash.startsWith("#!/l/")) {
            screenId = "/" + window.location.hash.split("/").slice(-1)[0].split(".").slice(-1)[0].split("?")[0];
        } else {
            screenId = window.location.hash.split("/").slice(-1)[0].split("?")[0];
        }
        const helpUrl = this.getAttribute("helpUrl");
        if (helpUrl != null && helpUrl.length > 0) {
            this.getIntro(helpUrl + screenId + ".html");
        }
        this.innerHTML = "";
    }

    private getIntro(url) {
        fetch(url)
            .then(this.status)
            .then(response => response.text())
            .then((html) => {

                // Convert the HTML string into a document object
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                let firstParagraph = doc.querySelector("#content p");
                this.innerHTML = template({
                    url,
                });
                if (firstParagraph != null) {
                    this.setAttribute("title", firstParagraph.textContent?.replace(/\s+/g,' '));
                }
            })
            .catch(error => {
                console.warn('Documentation not found:', error);
            });
    }
    private status = (response) => {
        if (response.ok) {
            return response;
        }
        this.style.display = "none";
        return Promise.reject({ err: response.status });
    }
}

export function initHelpIconlWebComponent() {
    window.customElements.define("s6-help-icon", HelpIconElement);
}
